import styled from 'styled-components';
import theme, { themeColors } from 'themes';
import styledTheme from 'common/theme';

interface DropAreaProps {
  isDragAccept: boolean;
}

export const FileUploadContainer = styled.div`
  width: 100%;

  .file-area {
    display: flex;
    width: 100%;
    margin-top: 0.625rem;
    padding: 0.75rem;
    text-align: left;
    flex-direction: row;
    column-gap: 0.625rem;
    align-items: start;
    border-radius: 8px;
    border: 1px solid ${styledTheme.colors.gray300};
  }

  .file-info {
    width: 90%;
    word-wrap: anywhere;
    .fileName {
      display: flex;
      gap: 0.3rem;
      justify-content: space-between;
    }
  }

  .file-size {
    .white-space: nowrap;
  }

  .file-status {
    margin-top: 2px;
    gap: 0.75rem;
    display: flex;
    align-items: center;
    .status {
      display: flex;
      gap: 0.25rem;
      font-size: 12px;
      line-height: 16px;
      cursor: pointer;
      margin: 0;
      .icon {
        height: 14px;
      }
    }
  }

  .delete-icon {
    cursor: pointer;
    padding-top: 4px;
    .icon--x {
      height: 10px;
      width: 10px;
    }
  }
`;

export const ImageDragInBox = styled.div<DropAreaProps>`
  width: 100%;
  border: 1px dashed ${theme.colors.tableborder};
  border-radius: 8px;
  cursor: pointer;
  background-color: ${(props) => (props.isDragAccept ? 'rgba(200, 120, 204, 0.1)' : 'transparent')};
  border-color: ${(props) =>
    props.isDragAccept ? theme.colors.tableborder : theme.colors.mediumGrey2};
  &:hover {
   border-color: ${theme.colors.primaryBlue5};
  }

  .drag-area {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 1.5rem 1.25rem;
  }
  
  .upload-icon-wrapper {
    width: 2rem;
    height: 2rem;
    border-radius: 1rem; 
    background-color: #F5FAFD;
    padding: 6px 7.5px;
  }

  .drag-prompt {
    font-weight: 400;
    font-size: 14px;
    line-height: 1rem;
    align-text: center;
    margin: 20px 0 8px;
  }

  .file-type-and-size-text {
    font-weight: 400;
    font-size: 0.75rem;
    line-height: 1rem;
    color: ${themeColors.mediumGrey4};
  }
`;
